import React from 'react';
import { Button } from './ui/button';
import { useLang } from '../i18n/LanguageContext';

export const Hero = () => {
  const { t } = useLang();

  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="min-h-[70vh] flex items-center justify-center pt-16 pb-8 lg:pt-20 lg:pb-12"
    >
      <div className="section-container w-full">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h1
            className="text-6xl sm:text-7xl lg:text-8xl font-bold tracking-tight text-balance"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {t.hero.name}
          </h1>

          <p className="text-xl sm:text-2xl lg:text-3xl text-muted-foreground font-light tracking-wide">
            {t.hero.title}
          </p>

          <div className="max-w-2xl mx-auto">
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
              {t.hero.intro}
            </p>
          </div>

          <div className="pt-6">
            <Button
              onClick={scrollToProjects}
              size="lg"
              className="bg-accent hover:bg-accent-hover text-accent-foreground font-medium px-8 py-6 text-base rounded-sm transition-all hover:shadow-lg group"
              data-testid="hero-cta-btn"
            >
              {t.hero.cta}
              <svg
                className="ml-2 w-5 h-5 transition-transform group-hover:translate-y-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </Button>
          </div>

          <div className="pt-2 animate-bounce">
            <svg className="w-6 h-6 mx-auto text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};
